import SpecType from "./SpecType";

export default class SealSpec {
    constructor(type) {
        this.label = this._getLabel(type);
        this.value = type;
        this.children = this._getChildren(type);
    }

    _getLabel(type) {
        return this._getTypeText(type);
    }

    _getTypeText(type) {
        const typeLables = {
            CIRCULAR: '圆形',
            // RECTANGLE: '长方形',
            SQUARE: '正方形',
            OVAL: '椭圆形'
        };
        return typeLables[type];
    }
    _getChildren(type) {
        const childrenMap = new Map([
            ['CIRCULAR', [new SpecType(type, 38), new SpecType(type, 39), new SpecType(type, 40), new SpecType(type, 41), new SpecType(type, 42), new SpecType(type, 43), new SpecType(type, 44), new SpecType(type, 45), new SpecType(type, 50), new SpecType(type, 60)]],
            ['SQUARE', [new SpecType(type, 25, 25), new SpecType(type, 22, 22), new SpecType(type, 18, 18)]],
            ['OVAL', [new SpecType(type, 40, 30)]],
        ]);
        return childrenMap.get(type);
    }

}

